<template>
  <div>
    <h4 style="color: red;margin-bottom: 0">未匹配上的来源SKU</h4>
  <Table :info="tableInfo" class="sku-data-table">
    <template #skuNameTitle>
      来源SKU ({{ list.length }}个)
    </template>
    <template #skuName="{ record }">
      <span>
        {{ record.sell_properties[0].value_name }}
        <template v-if="record.sell_properties[1]?.value_name">
          - {{ record.sell_properties[1].value_name }}
        </template>
        <template v-if="record.sell_properties[2]?.value_name">
          - {{ record.sell_properties[2].value_name }}
        </template>
        <a-tooltip placement="top">
          <template #title>
            点击复制sku
          </template>
          <CopyOutlined @click="copyStr(record)" />
        </a-tooltip>
      </span>
    </template>
    <template #originPrice="{ record }">
      {{ record.origin_price }}
    </template>
    <template #originStockNum="{ record }">
      {{ record.origin_stock_num || record.origin_stock || 0 }}
    </template>
  </Table>
  </div>
</template>
<script>
import tableHandler from './table_info'
import { CopyToClipboard } from '@/utils/co_utils'
import { CopyOutlined } from '@ant-design/icons-vue'
export default {
  components: { CopyOutlined },
  props: {
    list: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      tableInfo: {
        page: 1,
        pageSize: 10000,
        hideOnSinglePage: true,
        loading: false,
        list: this.list,
        columns: tableHandler.columns,
        total: 0,
        tableScroll: { y: 500 },
        renderSlot: [
          "skuName",
          "originPrice",
          "originStockNum",
          'skuNameTitle'
        ],
        showTotal: total => `共 ${total} 个规格值`,
        rowSelection: null,
        rowKey: 'outer_sku_id'
      }
    }
  },
  methods: {
    copyStr(item) {
      let str = ''
      for (let sku of item.sell_properties) {
        console.log(sku)
        str+= (sku.value_name || '')
      }
      CopyToClipboard(str)
      this.$message.success('已成功复制商品链接')
    }
  }
}
</script>
<style scoped lang='less'>
  .sku-data-table {
    width: 450px;
    :deep(.ant-table) {
      .ant-table-thead > tr > th,
      .ant-table-tbody > tr > td {
        font-size: 12px;
        padding: 4px;
      }
    }
  }
</style>